// data/aboutKeyInitiatives.js
const aboutKeyInitiatives = [
  {
    title: '<strong>Breathing Life</strong> Into Education',
    icon: '/images/EducationIcon.png',
    image: '/images/EducationImage.jpeg',
    text: "Following Gurudev's aspiration for universal value education, the Art of Living delivers free, comprehensive, and values-oriented education to children unreachable by standard government or private programs via the 'Care for Children' initiative.",
    bgcolor:
      'linear-gradient(to left top, rgb(110, 197, 246), rgb(255, 246, 220) 78%)',
  },
  {
    title: '<strong>Environment</strong> Sustainability',
    icon: '/images/Environment.webp',
    image: '/images/EnvironmentImage.webp',
    text: "Gurudev's vision has inspired volunteers globally to undertake significant environmental endeavors—including extensive tree planting through Mission Green Earth, innovative water management, river rejuvenation, and promoting zero-budget, chemical-free farming that's both economically viable and ecologically responsible.",
    bgcolor:
      'linear-gradient(to left top, rgb(155, 225, 177), rgb(255, 246, 220) 78%)',
  },
  {
    title: '<strong>Women</strong> Empowerment',
    icon: '/images/WomenEmpowerIcon.webp',
    image: '/images/WomenEmpowerImage.webp',
    text: "The Art of Living empowers women from all backgrounds by offering programs designed to cultivate inner strength, creativity, and self-assurance. These programs enable women to face the world with skill, confidence, and grace, fully prepared to tackle life's challenges",
    bgcolor:
      'linear-gradient(to left top, rgb(175, 189, 249), rgb(255, 246, 220) 78%)',
  },
  {
    title: '<strong>Disaster Relief</strong> Management',
    icon: '/images/HeartIcon.webp',
    image: '/images/ReliefManagementImage.webp',
    text: "The Art of Living's multifaceted approach to disaster relief ensures immediate and effective support to those in need. Leveraging a global network of volunteers, the Art of Living can quickly respond to crises anywhere on the planet.",
    bgcolor:
      'linear-gradient(to left top, rgb(254, 219, 154), rgb(255, 246, 220) 78%)',
  },
  {
    title: '<strong>Prisoner</strong> Rehabilitation',
    icon: '/images/PersonIcon.webp',
    image: '/images/PrisionerRehabilitationImage.webp',
    text: 'The IAHV Prison Program (formerly Prison SMART) is an internationally acclaimed initiative aimed at transforming the attitudes and behaviors of offenders. It seeks to eradicate societal violence at its core, reduce re-offending, and provide essential stress management and trauma relief for correctional staff and crime victims.',
    bgcolor:
      'linear-gradient(to left top, rgb(251, 167, 147), rgb(255, 246, 220) 78%)',
  },
  {
    title: '<strong>Conflict</strong> Resolution',
    icon: '/images/GlobeIcon.webp',
    image: '/images/PeaceConfiltResolution.webp',
    text: 'Under the guidance and mediation of Gurudev, the Art of Living has been instrumental in resolving conflicts, bringing reconciliation, and instilling harmony in diverse communities and regions across the globe.',
    bgcolor:
      'linear-gradient(to left top, rgb(156, 219, 234), rgb(255, 246, 220) 78%)',
  },
];
export default aboutKeyInitiatives;
